import { defineStore } from 'pinia'
import { is, any, start, end, progress, percent, endProgress } from '../components/wait/waitUtils'

export const useWaitStore = defineStore('wait', {
  state: () => ({
    waitingFor: [],
    progresses: {}
  }),
  getters: {
    any: state => any(state.waitingFor)
  },
  actions: {
    percent: waiter => percent(this.progresses, waiter),
    is(waiter) {
      return is(this.waitingFor, waiter)
    },
    start(waiter) {
      this.waitingFor = start(this.waitingFor, waiter)
    },
    end(waiter) {
      this.waitingFor = end(this.waitingFor, waiter)
      this.progresses = endProgress(this.progresses, waiter)
    },
    progress({ waiter, current, total }) {
      this.progresses = progress(this.progresses, waiter, current, total)
    }
  }
})
